import { useLocation } from "@swa-ui/browser";

import { getSearchParams } from "../getSearchParams";

/**
 * Gathers the search params of the current href
 * @param {ObjectSchema} validations Optional validations to run against the parameters
 * @returns An object with search params and errors
 */
export const useSearchParams = (validations) => {
  const { search } = useLocation();

  return getSearchParams(search, validations);
};
